var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.293 12.707a1 1 0 001.414 0l6.364-6.364a1 1 0 00-1.414-1.414L8 10.586 2.343 4.929A1 1 0 00.93 6.343l6.364 6.364zM7 11v1h2v-1H7z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMjkyODkgMTIuNzA3MUM3LjY4MzQyIDEzLjA5NzYgOC4zMTY1OCAxMy4wOTc2IDguNzA3MTEgMTIuNzA3MUwxNS4wNzExIDYuMzQzMTVDMTUuNDYxNiA1Ljk1MjYyIDE1LjQ2MTYgNS4zMTk0NiAxNS4wNzExIDQuOTI4OTNDMTQuNjgwNSA0LjUzODQxIDE0LjA0NzQgNC41Mzg0MSAxMy42NTY5IDQuOTI4OTNMOCAxMC41ODU4TDIuMzQzMTUgNC45Mjg5M0MxLjk1MjYyIDQuNTM4NDEgMS4zMTk0NiA0LjUzODQxIDAuOTI4OTMyIDQuOTI4OTNDMC41Mzg0MDggNS4zMTk0NiAwLjUzODQwOCA1Ljk1MjYyIDAuOTI4OTMyIDYuMzQzMTVMNy4yOTI4OSAxMi43MDcxWk03IDExTDcgMTJMOSAxMkw5IDExTDcgMTFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgArrow as ReactComponent };